var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseiconwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2231 12.3871C13.4579 12.6219 13.4579 12.9871 13.2231 13.2219C13.1057 13.3393 12.9622 13.3914 12.8057 13.3914C12.6492 13.3914 12.5057 13.3393 12.3883 13.2219L10.0013 10.8349L7.61439 13.2219C7.49699 13.3393 7.35352 13.3914 7.19699 13.3914C7.04047 13.3914 6.89699 13.3393 6.7796 13.2219C6.54482 12.9871 6.54482 12.6219 6.7796 12.3871L9.16656 10.0001L6.7796 7.61316C6.54482 7.37838 6.54482 7.01316 6.7796 6.77838C7.01439 6.5436 7.3796 6.5436 7.61439 6.77838L10.0013 9.16534L12.3883 6.77838C12.6231 6.5436 12.9883 6.5436 13.2231 6.77838C13.4579 7.01316 13.4579 7.37838 13.2231 7.61316L10.8361 10.0001L13.2231 12.3871Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseiconwhite);
export default __webpack_public_path__ + "static/media/closeicon white.8001ca43d419b7cd5e7e6781a9a9a340.svg";
export { ForwardRef as ReactComponent };